import React from 'react';
import Template from '../../components/expertise/template'

const RealEstate = ()=> {
    return <Template expertise="realestate" id={2} />
}
export default RealEstate